/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './retail-product-creatives-modal.component.html';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {LayoutResource} from '../../components/api/resources/resource/layout.resource';

export interface RetailProductCreativesModalResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-retail-product-creatives-modal',
  template
})
export class RetailProductCreativesModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  bulkSelection: any[] = [];

  readonly onCreated = new Subject<RetailProductCreativesModalResult>();

  lineItem: any = {};
  destination = true;
  refLayout: any;
  validationErrors: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(CreativeResource) private readonly Creative: any,
    @Inject(LayoutResource) private readonly Layout: any,
    private readonly ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.Layout.query().$promise.then((page: any) => {
      this.ngZone.run(() => {
        _.forEach(page.results, (layout: any) => {
          if (layout.detectedCategory === 'RETAIL') {
            this.refLayout = layout;
          }
        });
      });
    });
  }

  createRetailCreatives(): void {
    if (!this.refLayout?.id) {
      return;
    }

    const allPromises: any[] = [];
    const merchantGuide = LocalNetworkInfo.obtain().getMerchantGuide();
    _.forEach(this.bulkSelection, (rp: any) => {
      const merchantLink = merchantGuide[rp.merchantId].link;
      allPromises.push(this.Creative.retailAd(_.get(this, ['lineItem', 'id']), '', this.refLayout.id, merchantLink, rp.itemId));
    });
    Promise.all(allPromises).then(() => {
      this.ngZone.run(() => {
        this.onCreated.next({model: this.lineItem, destination: this.destination});
        this.bsModalRef.hide();
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
